module.exports = {
    "Clear search": `I\u{161}valyti ie\u{161}k\u{105}`
};


//# sourceMappingURL=lt-LT.main.js.map
